import React, { useCallback, useMemo } from "react";
import { couponService } from "../../api/services/coupon.service";
import { useInfiniteQuery } from "@tanstack/react-query";
import CouponShoppingItem from "../coupon/CouponShoppingItem";
import CouponSelectSheet from "../coupon/CouponSelectSheet";

const CouponShoppingSelectModal = (props) => {
  const fetchData = useCallback(
    async ({ pageParam = 1 }) => {
      const response = await couponService.getCouponsByPage(pageParam);
      return response.data;
    },
    []
  );

  const { data, isSuccess, isLoading, fetchNextPage, hasNextPage } = useInfiniteQuery({
    queryKey: ["userCouponSelectionList"],
    initialPageParam: 1,
    queryFn: async ({ pageParam = 1 }) => {
      const data = await fetchData({ pageParam });
      return data;
    },
    getNextPageParam: (lastPage) => {
      if (lastPage && lastPage.next) {
        const match = lastPage.next.match(/page=(\d+)/);
        if (match) {
          return match[1];
        }
      }
      return undefined;
    },
  });

  const filteredCoupons = useMemo(() => {
    if (!data || !isSuccess) return [];

    return data.pages.flatMap((page, i) =>
      page.results
        .filter((coupons) => coupons.coupon.bound_type === "shopping" && coupons.state === "사용안함")
        .map((coupon, j) => (
          <CouponShoppingItem
            key={`${i}-${j}`}
            coupon={coupon}
            targetItem={props.targetItem}
            selectCoupon={props.selectCoupon}
            toggleShoppingDiscountCouponSelection={props.toggleShoppingDiscountCouponSelection}
          />
        ))
    );
  }, [data, isSuccess, props.targetItem, props.selectCoupon, props.toggleShoppingDiscountCouponSelection]);

  const isCouponSelected = props.selectCoupon?.some(
    (c) =>
      String(c.product_id) === String(props.targetItem?.product_id) &&
      String(c.option_id) === String(props.targetItem?.option_id)
  );

  return (
    <CouponSelectSheet
      isOpen={props.visible}
      onClose={() => props.setVisible(false)}
      onApply={() => props.setVisible(false)}
      applyDisabled={!isCouponSelected}
      loading={isLoading}
      isEmpty={isSuccess && filteredCoupons.length === 0}
      hasMore={hasNextPage}
      onLoadMore={() => fetchNextPage()}
    >
      {filteredCoupons}
    </CouponSelectSheet>
  );
};
export default React.memo(CouponShoppingSelectModal);
